export default __webpack_public_path__ + "static/media/spd.b6642ec7.svg";